import * as THREE from 'three';
import { BaseEnemy } from './base.js';
import { ENEMY_STATS } from '../../data/enemies.data.js';

export class Enforcer extends BaseEnemy {
  constructor(opts) {
    super({ ...opts, stats: ENEMY_STATS.enforcer });
    this.strafeDir = Math.random() < 0.5 ? 1 : -1;
    this.strafeTimer = 0;
    this._burstLeft = 0;
    this._burstTimer = 0;
  }

  buildMesh() {
    super.buildMesh();
    // Slightly larger shoulders
    const shoulder = new THREE.Mesh(
      new THREE.BoxGeometry(1.1, 0.25, 0.55),
      new THREE.MeshStandardMaterial({ color: this.stats.accentColor, roughness: 0.7 })
    );
    shoulder.position.y = 1.22;
    shoulder.castShadow = true;
    this.group.add(shoulder);
  }

  updateAI(dt, game) {
    const player = game.player;
    if (!player.alive) return;
    const d = this.distTo(player.x, player.z);
    this.sensePlayer(game, dt);

    const targetX = player.x;
    const targetZ = player.z;
    this.aimX = targetX - this.x;
    this.aimZ = targetZ - this.z;
    const aimLen = Math.hypot(this.aimX, this.aimZ) || 1;
    this.aimX /= aimLen; this.aimZ /= aimLen;

    // Strafe around preferred distance (~7m)
    const preferred = 7;
    this.strafeTimer -= dt;
    if (this.strafeTimer <= 0) {
      this.strafeDir = Math.random() < 0.5 ? 1 : -1;
      this.strafeTimer = 1.2 + Math.random() * 1.2;
    }

    if (!this._lastCanSeePlayer) {
      this.state = 'chase';
      this.moveWithPathfinding(targetX, targetZ, dt, game, 0.9);
      return;
    }

    let tx, tz;
    if (d > preferred + 1) {
      tx = player.x;
      tz = player.z;
    } else if (d < preferred - 1) {
      tx = this.x - this.aimX * 2;
      tz = this.z - this.aimZ * 2;
    } else {
      // strafe perpendicular
      const px = -this.aimZ * this.strafeDir;
      const pz = this.aimX * this.strafeDir;
      tx = this.x + px * 2;
      tz = this.z + pz * 2;
    }
    this.moveToward(tx, tz, dt, game.room.walls, 0.85);

    // Override aim direction back to player (moveToward overwrites it)
    this.aimX = targetX - this.x;
    this.aimZ = targetZ - this.z;
    const a2 = Math.hypot(this.aimX, this.aimZ) || 1;
    this.aimX /= a2; this.aimZ /= a2;

    // Fire burst
    if (this._burstLeft > 0) {
      this._burstTimer -= dt;
      if (this._burstTimer <= 0) {
        const sp = this.stats.spread;
        const ang = Math.atan2(this.aimX, this.aimZ) + (Math.random() * 2 - 1) * sp;
        const dx = Math.sin(ang), dz = Math.cos(ang);
        game.spawnEnemyProjectile(
          this.x + dx * 0.7, this.z + dz * 0.7, dx, dz,
          { speed: this.stats.projectileSpeed, damage: this.stats.projectileDamage, life: 1.2 }
        );
        this.playFireRecoilAnim();
        this._burstLeft--;
        this._burstTimer = this.stats.burstInterval;
      }
    } else if (this.fireCd <= 0 && this._lastCanSeePlayer) {
      this._burstLeft = this.stats.burstCount;
      this._burstTimer = 0;
      this.fireCd = this.stats.fireCooldown;
    }
  }
}
